module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Michael J. Gorman\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v(" "), _c('B', [_vm._v("Michael J. Gorman")]), _vm._v(" holds the Raymond E. Brown Chair in Biblical Studies and Theology at St. Mary's Seminary & University in Baltimore, Maryland, where he has taught since 1991. A highly regarded New Testament scholar, he has also written "), _c('I', [_vm._v("Cruciformity, Inhabiting the Cruciform God, Becoming the Gospel")]), _vm._v(", and "), _c('I', [_vm._v("Apostle of the Crucified Lord")]), _vm._v(", among other significant works.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/wKLivJ/image/9780802868848.jpg?1684515198010",
      "alt": "This image is the cover for the book Becoming the Gospel, The Gospel and Our Culture Series (GOCS)"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Becoming the Gospel, The Gospel and Our Culture Series (GOCS)\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The first detailed exegetical treatment of Paul’s letters from the emerging discipline of missional hermeneutics, Michael Gorman’s "), _c('i', [_vm._v("Becoming the Gospel")]), _vm._v(" argues that Paul’s letters invite Christian communities both then and now to not merely "), _c('i', [_vm._v("believe")]), _vm._v(" the gospel but to "), _c('i', [_vm._v("become")]), _vm._v(" the gospel and, in doing so, to participate in the life and mission of God."), _c('br'), _c('br'), _vm._v("Showing that Pauline churches were active public participants in and witnesses to the gospel, Gorman reveals the missional significance of various themes in Paul’s letters. He also identifies select contemporary examples of mission in the spirit of Paul, inviting all Christians to practice Paul-inspired imagination in their own contexts.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Wm. B. Eerdmans Publishing \n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0